import { 
  useEffect
} from 'react';
import { Route, Redirect } from 'react-router-dom';
import navBarStore from '../../../stores/NavBar';

const PrivateRouteC = ({ component: Component, _if, ...rest }) => {

  const navBar = navBarStore();

  useEffect(()=>{
    if ( rest.fullscreen === true ) {
      navBar.hide();
    } else {
      navBar.show();
    }
  }, [])

  return (
    <Route
      {...rest}
      render={props =>
        _if() ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  );
}

export default PrivateRouteC;